(function($, undefined) {
	
	'use strict';	
	var utils;
	var addTooltipBtn;
	var addHighlightBtn;
	var saveBtn;
	var selection;
	var tooltipCount = 1;
	var highlightCount = 1;
	
	var lexiqueCache = {};

	var addTooltip = function() {
		var highlightedText = "";
	    
	    if (window.getSelection) {
	        highlightedText = window.getSelection().toString();
	    } 
	    else if (document.selection && document.selection.type != "Control") {
	        highlightedText = document.selection.createRange().text;
	    }

		if(highlightedText != ""){
		    var popup = $('#tooltip-create-popup');
		    $('.form-input', popup).val("");
    		popup.addClass('visible');
    		selection= window.getSelection().getRangeAt(0);
		}
	};

	var createTooltip = function() {
		var tooltipText = $('#story-tooltip-text-input')[0].value;

		var popup = $('#tooltip-create-popup');
		popup.removeClass('visible');

		var tooltip = document.createElement("span");
		tooltip.className = "tooltip";
		tooltip.innerHTML = tooltipText;

		var tooltip2 = tooltip.cloneNode(true);

		/**Inserting 2 instances of the tooltip to bypass the span node split when highlighting parts of the tooltip element**/
	    var selectedText = selection.extractContents();
	    var span= document.createElement("span");
	    span.className = "tooltip-element";
	    span.setAttribute('data-tooltip-id', tooltipCount);
	    span.appendChild(tooltip);
	    span.appendChild(selectedText);
	    span.appendChild(tooltip2);
	    selection.insertNode(span);

	    tooltipCount++;

	    $('.tooltip-element').dblclick(editTooltip);
	};

	var editTooltip = function() {
		var t = $(this);
		
		var popup = $('#tooltip-edit-popup');
		$('.form-input', popup).val($('.tooltip', t).first().text());
		popup.addClass('visible');

		$('.remove-story-tooltip-btn').click(function() {
			var tooltipId = t.attr('data-tooltip-id');
			$('span[data-tooltip-id = '+tooltipId+']').find('.tooltip').remove();
			$('span[data-tooltip-id = '+tooltipId+']').contents().unwrap();
			popup.removeClass('visible');
		});

		$('.edit-story-tooltip-btn').click(function() {
			var tooltipText = $('#story-edit-tooltip-text-input')[0].value;
			var tooltip = t.find('.tooltip');
			console.log(tooltipText);
			tooltip[0].innerHTML = tooltipText;
			popup.removeClass('visible');
		});
	};

	var addHighlight = function() {
		selection= window.getSelection().getRangeAt(0);
		
		// highlight only text from the story (title and text)
		if ($(selection.commonAncestorContainer).hasClass('story-detail-content-text') || 
			$(selection.commonAncestorContainer).closest('.story-detail-content-text').length) {
			
			// Highlighting title and text at the same time causes layout bug and no highlight... avoid.
			if (!($(selection.startContainer.parentElement).hasClass('story-title') &&
				$(selection.endContainer.parentElement).closest('.text-ctn').length)) {
				
				var selectedText = selection.extractContents();
				var span= document.createElement("span");
				span.className = "highlight";
				span.setAttribute('data-highlight-id', highlightCount++);
				span.appendChild(selectedText);
				selection.insertNode(span);

				$('.highlight').dblclick(editHighlight);
			}
		}
	    
	};

	var editHighlight = function() {
		var t = $(this);
		
		var popup = $('#highlight-edit-popup');
		popup.addClass('visible');

		$('.remove-story-highlight-btn').click(function() {
			var highlightId = t.attr('data-highlight-id');
			$('span[data-highlight-id = '+highlightId+']').find('.highlight').remove();
			$('span[data-highlight-id = '+highlightId+']').contents().unwrap();
			popup.removeClass('visible');
		});

		$('.edit-story-hightlight-btn').click(function() {
			popup.removeClass('visible');
		});
	};

	var saveVersion = function() {
		
	};

	var openLexiqueTooltip = function(e) {
		e.stopPropagation();
		var t = $(this);
		var lexiqueWordId = t.attr('data-id');

		var popup = $('#lexique-word-popup');
		popup.addClass('visible');

		var contentWrapper = popup.find('.lexique-word-popup-inner');
		var img = popup.find('.lexique-word-popup-image');
		var title = popup.find('.popup-title');
		
		getLexiqueWord(lexiqueWordId, function(titleText, imgPath, definition) {
			title.text(titleText);
			if (imgPath.length > 0) {
				img.show();
				img.attr('src', imgPath);
			} else {
				img.hide();
			}
			contentWrapper.html(definition);
		});

		$('.lexique-word-popup-btn').click(function() {
			popup.removeClass('visible');
			contentWrapper.empty();
		});
	};
	
	var getLexiqueWord = function(id, callback) {
		if (lexiqueCache[id]) {
			callback(lexiqueCache[id].title, lexiqueCache[id].img, lexiqueCache[id].definition);
		} 
		else {
			utils.getGenData(id, function(response) {
				var titleText = $(response)[0].attributes.field2 ? $(response)[0].attributes.field2.value : "";
				var imgPath = $(response)[0].attributes.field3 ? $(response)[0].attributes.field3.value : "";
				var definition = $(response)[0].attributes.field4 ? $(response)[0].attributes.field4.value : "";
				
				addWordToLexiqueCache(id, titleText, imgPath, definition);
				callback(titleText, imgPath, definition);
			});
		}
	};
	
	var addWordToLexiqueCache = function(id, title, img, definition) {
		var newItem = {
			title: title,
			img: img,
			definition: definition
		};
		lexiqueCache[id] = newItem;
	};
	
	var init = function () {
		utils = Fw.component.models().utils;

		addTooltipBtn = $('.add-tooltip');
		addHighlightBtn = $('.add-highlight');
		saveBtn = $('.save-version');
		
		addTooltipBtn.click(addTooltip);
		addHighlightBtn.click(addHighlight);
		saveBtn.click(saveVersion);

		$('.add-story-tooltip-btn').click(createTooltip);
		$('body').on('click', '.lexique-word', openLexiqueTooltip);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
